// API Configuration based on environment
import { API_BASE_URL as ENV_API_BASE_URL } from './environment';

export const API_BASE_URL = ENV_API_BASE_URL;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

// Common API endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    GOOGLE_URL: '/api/auth/google',
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    PROFILE: '/api/profile'
  },
  // Members (now site-specific)
  SITE_MEMBERS: (siteId) => `/api/sites/${siteId}/members/`,
  SITE_MEMBER: (siteId, memberId) => `/api/sites/${siteId}/members/${memberId}`,
  // Sports
  SPORTS: '/api/sports/',
  SPORT: (id) => `/api/sports/${id}`,
  // Sites
  SITES: '/api/sites',
  SITE: (id) => `/api/sites/${id}`,
  // Plans
  PLANS: '/api/plans',
  SITE_PLAN: (siteId) => `/api/sites/${siteId}/plan`,
  // Modules
  MODULES: '/api/modules',
  SITE_MODULES: (siteId) => `/api/sites/${siteId}/modules`,
  SITE_MODULE: (siteId, moduleId) => `/api/sites/${siteId}/modules/${moduleId}`,
  // Navigation
  LOG_NAVIGATION: '/api/log-navigation',
  // Add more endpoints as needed
};

// Helper function to get auth token
const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

// Helper function to make authenticated requests
export const authenticatedFetch = async (url, options = {}) => {
  const token = getAuthToken();
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    }
  };

  const response = await fetch(url, { ...defaultOptions, ...options });
  
  // If token is expired, try to refresh
  if (response.status === 401 && token) {
    try {
      const refreshResponse = await fetch(buildApiUrl(API_ENDPOINTS.AUTH.REFRESH), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (refreshResponse.ok) {
        const { token: newToken } = await refreshResponse.json();
        localStorage.setItem('auth_token', newToken);
        
        // Retry original request with new token
        return fetch(url, {
          ...defaultOptions,
          ...options,
          headers: {
            ...defaultOptions.headers,
            'Authorization': `Bearer ${newToken}`
          }
        });
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      // Clear invalid token
      localStorage.removeItem('auth_token');
    }
  }
  
  return response;
};

const apiConfig = {
  API_BASE_URL,
  buildApiUrl,
  API_ENDPOINTS,
};

export default apiConfig;
